export default "__VITE_ASSET__accda514__"